import * as ACTION_TYPES from "./action-types";

export const setSelectedUser = (data) => {
  return {
    type: ACTION_TYPES.SET_SELECTED_USER,
    payload: data,
  };
};

export const setShowProfileSettings = (data) => {
  return {
    type: ACTION_TYPES.SHOW_PROFILE_SETTINGS,
    payload: data,
  };
};

export const setShowConfirmationModal = (data) => {
  return {
    type: ACTION_TYPES.SHOW_CONFIRMATION_MODAL,
    payload: data,
  };
};

export const showOrganizationInfo = (show) => ({
  type: ACTION_TYPES.SHOW_ORGANIZATION_INFO,
  payload: show,
});

/**
 * Sets the active sidebar in Manage Organization
 * @param {string} sidebar - The active sidebar name
 * @author Sejal
 */
export const setActiveOrganizationSidebar = (sidebar) => ({
  type: ACTION_TYPES.SET_ACTIVE_ORGANIZATION_SIDEBAR,
  payload: sidebar,
});